/**
 * 处理表单的字段相关的
 */
export function getValueStr(scheme, event) {
    if (!scheme) return null
    let str
    switch (scheme.category) {
        case "picker":
        case "radio":
            let option = scheme.__slot__.options.find(v => v.value == event)
            str = option != undefined ? option.label : event
            break
        case "checkbox":
            let options = scheme.__slot__.options.filter(v => event.includes(v.value))
            str = options.map(v => v.label).join(",")
            break
        case "timerange":
        case "daterange":
            str = event && event.length ? event.join("~") : ''
            break
        case "cascader":
            let i = 0

            function traverse(child) {
                if (child == undefined) {
                    return
                }
                str = str == undefined ? child.label : str + "/" + child.label
                if (child.children != undefined) {
                    const index = event[++i]
                    let children = child.children.find(v => Number(v.value) == Number(index))
                    traverse(children)
                }
            }
            traverse(scheme.options.find(v => v.value == event[i]))
            break
        case "upload":
            str = event
            break
        case "selectBusiness":
            str = event && event.length ? event.map(v => v.label).join(",") : ''
            break
        case "number":
            str = event && scheme.unit ? event + ' ' + scheme.unit : event || ''
            break
        default:
            str = event
    }
    return str
}

export function getValueItem(scheme, event) {
    if (!scheme) return null
    let val
    switch (scheme.category) {
        case "selectBusiness":
            val = event && event.length ? event.map(v => v) : []
            break
        default:
            val = event
    }
    return val

}

export function canUseInPC(formConf) {
    return !formConf.fields.some(v => v.category == 'signature' && v.__config__.required == true)
}


export function tableColumns(config) {
    return config.fields.map(v => {
        return {
            field: v.__vModel__,
            label: v.__config__.label,
            value: 'content.' + v.__vModel__ + '.str'
        }
    })
}

export function merge(config, data) {
    if (!data || !data.content) return config
    config.fields.forEach(v => {
        if (data.content[v.__vModel__])
            v.__config__.defaultValue = data.content[v.__vModel__].value
    })
    return config
}


// WEBPACK FOOTER //
// ./src/components/form/parser/handle_sheme.js